// Commented these as part of Okta-Intra migration. Not sure if the unused vars can be deleted. Leaving this comment 
// in case something breaks
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./sidebar/sidebar";
// import { ROUTES } from "../utils/constants";
import "./generalLayout.scss";
// import { useSelector } from "react-redux";
// import { getAuth } from "../redux/auth/authSlice";
import { Toolbar } from "./toolbar/toolbar";

const GeneralLayout = () => {
  // const { userInfo } = useSelector(getAuth);
  // const navigate = useNavigate();
  const routesWithoutSidebar: any = [];
  const currentLocation = window.location.pathname;
  const showSidebar = !(
    routesWithoutSidebar.findIndex((route: any) => {
      const routeToCheck = `/${route}`;
      if (routeToCheck.indexOf(":") !== -1) {
        const paramsToDelete: number[] = [];
        const separateCurrentLocation = currentLocation.split("/");
        const routeWithParams = routeToCheck.split("/");
        routeWithParams.forEach((val, index) => {
          if (val.indexOf(":") !== -1) {
            paramsToDelete.push(index);
          }
        });
        paramsToDelete.forEach((indexParam, index) => {
          routeWithParams.splice(indexParam - index, 1);
          separateCurrentLocation.splice(indexParam - index, 1);
        });
        const checkLocationWithoutParams = routeWithParams.join("/");
        const checkCurrentLocationWithoutParams =
          separateCurrentLocation.join("/");
        return checkCurrentLocationWithoutParams === checkLocationWithoutParams;
      } else if (routeToCheck === currentLocation) {
        return true;
      } else return false;
    }) !== -1
  );

  useEffect(() => {
    // if (authState?.isAuthenticated === false || !userInfo) {
    //   navigate(`${ROUTES.login.route}`);
    // }
  }); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Toolbar />
      <div className="layout-wrapper">
        {showSidebar && <Sidebar />}
        <div className="content">
          <div
            className="lennar-container"
            style={{
              margin: !showSidebar ? "0" : "",
              width: !showSidebar ? "100%" : "",
              height: !showSidebar ? "calc(100% - 56px)" : "",
            }}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneralLayout;
